import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import UpdateIcon from '@mui/icons-material/Update';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function CustomersEditUpdateCurData(props) {
    //console.debug("RTS Break CustomersEditUpdateCurData");

    const {sessionCustomer, userLogOut, userAuthToken, apiRoot} = useSessionContext();


    const history = useNavigate();

    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorBody] = useState("");
    const [errorTitle] = useState("Validation Error");
    const [showConfirmModal, setShowConfirmModal] = useState(false);


    function handleYesClick(e){
        e.preventDefault();
        InitCurData();
    }


    function InitCurData(){
        props.updateCurDataFx(0);
        let apiURL = apiRoot + "/LoadList/InitCustomerCurData";
        axios
        .post(
            apiURL,
            sessionCustomer.customer, 
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            props.updateCurDataFx(1);
        })
        .catch(error => {
            if(error.status == 401){
                userLogOut();
            }
            else{
                props.setHasErrorFx(true);
                console.log("RTS Data Error", error);
            }
        });
    }


    return (
        <>
        <Dialog open={showErrorModal} onClose={()=>{setShowErrorModal(false);}}>
            <DialogTitle>{errorTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorBody}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowErrorModal(false);}}>Close</Button>
            </DialogActions>
        </Dialog>
        <Dialog fullWidth={true} open={showConfirmModal}>
            <DialogTitle>Update Current Data?</DialogTitle>
            <DialogContent>
                <Typography>Update Customer Current Data?</Typography>
                <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <Typography variant="caption" sx={{my:1}}>This will re-calculate all current data for the customer's reels.</Typography>
                </Box>
                <Box sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                    <Typography variant='caption' color='red'>This may take a few minutes and cannot be undone...</Typography>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={handleYesClick}>Yes</Button>
                <Button variant="contained" onClick={e => {setShowConfirmModal(false);}}>No</Button>
            </DialogActions>
        </Dialog>
        <Button startIcon={<UpdateIcon />} 
                variant="contained" 
                onClick={() => {setShowConfirmModal(true);}} 
                sx={{mr:2}}
        >Update Current Data</Button>
        </>
    );

}
